import React, { useState } from 'react';
import { FeatureContainer } from 'components/molecules/Containers/FeatureContainer';
import { LabelInput } from 'components/atoms/Inputs/LabelInput';
import { useLazyQuery } from '@apollo/client';
import QUERY_RELAIS from 'graphql/query/relais/relais.query';
import {
  PointRelaisQuery,
  QueryPointRelaisArgs
} from 'graphql/generated/graphql';
import { ButtonWithText } from 'components/atoms/Buttons/ButtonWithText';
import DisplayRelais from './DisplayRelais';
import { errorAndStateParams } from 'helpers/forms/errorAndStateParams';
import { useSelector } from 'react-redux';
import { getSelectedPointRelais } from 'store/selectors/client.selectors';
import { HeaderText } from '../../../../../../atoms/Texts/HeaderText';
import emojis from 'theme/emoji';
import { Modal } from '../../../../../Modals/Modal';
import { zipCodeForPointsRelais } from 'helpers/zipCode/zipCodeForPointsRelais';
import toast from 'react-hot-toast';

interface StateAddress {
  values: QueryPointRelaisArgs;
  errors: QueryPointRelaisArgs;
}

const initAddress: StateAddress = {
  values: {
    address: null,
    city: null,
    zipCode: null
  },
  errors: {
    address: null,
    city: null,
    zipCode: null
  }
};

const onError = (e: Error) => toast.error(e.message);

const PublicShopFields = () => {
  const [{ values, errors }, setAddress] = useState<StateAddress>(initAddress);
  const [pointsRelais, setPointsRelais] = useState([]);

  const [getPointRelais, { loading, refetch, called }] = useLazyQuery<
    PointRelaisQuery
  >(QUERY_RELAIS, {
    onError,
    onCompleted: data => {
      setPointsRelais(zipCodeForPointsRelais(data.pointRelais));
    }
  });
  const selectedPointRelais = useSelector(getSelectedPointRelais);

  const handleChange = e => {
    const value = e.target.value;
    const name = e.target.name as 'address' | 'city' | 'zipCode';
    setAddress(
      errorAndStateParams(name, value, { values, errors, isValid: false })
    );
  };
  const handleClick = async () => {
    try {
      await getPointRelais({
        variables: {
          address: values.address,
          city: values.city,
          zipCode: values.zipCode
        }
      });
      if (called) {
        const { data, error } = await refetch();
        if (error) return onError(error);
        setPointsRelais(zipCodeForPointsRelais(data.pointRelais));
      }
    } catch (e) {
      onError(e);
    }
  };

  return (
    <>
      <HeaderText text={'Point relais'} emoji={emojis['PostBox']} />
      <FeatureContainer>
        <LabelInput
          label="Votre code Postal pour trouver le point le plus proche"
          name="zipCode"
          placeHolder="75000"
          onChange={handleChange}
          value={values.zipCode || ''}
          error={errors && errors.zipCode}
        />
        <Modal
          modalHead={'Choissisez votre point relais'}
          triggerButton={
            <ButtonWithText
              content="Chercher des points relais"
              variant="secondaryBlue"
              onClick={handleClick}
              disabled={!values.zipCode}
              loading={loading}
            />
          }
          actionButton={<ButtonWithText content={'Valider'} onClick={null} />}
        >
          <DisplayRelais pointRelais={pointsRelais} />
        </Modal>
        <p>
          {selectedPointRelais.adresselivraison
            ? '✅ Vous avez sélectionné : ' + selectedPointRelais.fullName
            : '❌ Pas de point sélectionné'}
        </p>
      </FeatureContainer>
    </>
  );
};

export default PublicShopFields;
